import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveUserDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.user.remove ;
}

RemoveUserDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.users.url,
    useUrl : true
};

RemoveUserDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveUserDialog );
